<script setup lang="ts">
  import { SelectValue, type SelectValueProps } from "reka-ui"

  const props = defineProps<SelectValueProps>()
</script>

<template>
  <SelectValue v-bind="props" class="text-base">
    <slot />
  </SelectValue>
</template>
